import React from "react";
import SidebarLayout from "../layouts/SidebarLayout";
import { boardStatus } from "../constants/board";
import Skeleton from "./Skeleton";
import DatalineChart from "./chart/DatalineChart";
import { useState, useEffect } from "react";
import axios from "axios";

const Dashboard = () => {

  const [leadStats, setLeadStats] = useState(null);
  const [leadsError, setLeadsError] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchLeadStats = async () => {
      try {
        const response = await axios.get(`/crm?type=leadStats`, {
          headers: { "x-api-key": process.env.REACT_APP_X_API_KEY_CRM },
        });
        setLeadStats(response.data?.data || {});
        console.log("from dashboard leads stats",response.data?.data);
      } catch (error) {
        setLeadsError(error);
        console.error("Error fetching lead stats:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchLeadStats();
  }, [])
  return (
    <SidebarLayout>
      <div className="px-3 md:px-6 lg:px-8 py-2 md:py-4 lg:py-6 ">
        <div className="flex justify-between items-center">
          <h2 className="md:text-3xl text-lg font-semibold leading-3 mt-2 text-heading-1">
            Dashboard
          </h2>
          {/* Dates & filters */}

        </div>

        <div className="mt-10">
          {!leadStats && !leadsError ? (
            <Skeleton type={"dashboard"} />
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-5 gap-5">
              {Object.keys(boardStatus).map((key, index) => (
                <div
                  key={`${key}__dashboard__${index}`}
                  className={`py-5 px-4 rounded-xl bg-transparent  border border-border ${Object.keys(boardStatus).length - 1 === index
                    ? "col-span-2 md:col-span-1"
                    : ""
                    }`}
                >
                  <p className="text-sm font-medium mb-2  text-heading-2">
                    {boardStatus[key]}
                  </p>
                  <div>
                  <h3 className="text-3xl  text-white text-heading-2 font-semibold">
                    {leadStats?.[key] || 0}
                  </h3>
                 <h1></h1>
                  </div>

              
                </div>
              ))}
            </div>
          )}
        </div>
        <div>
          <DatalineChart />
        </div>
      </div>
    </SidebarLayout>
  );
};

export default Dashboard;
